import { render } from "./ItemPage.vue?vue&type=template&id=55543994&scoped=true"
import script from "./ItemPage.vue?vue&type=script&lang=js"
export * from "./ItemPage.vue?vue&type=script&lang=js"

import "./ItemPage.vue?vue&type=style&index=0&id=55543994&scoped=true&lang=css"
import "./ItemPage.vue?vue&type=style&index=1&id=55543994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55543994"]])

export default __exports__